import React from "react";
import { ToastContainer } from "react-toastify";
import BookmarkProvider from "./Context/Bookmark/BookmarkProvider";
import ChatProvider from "./Context/Chat/ChatProvider";
import ContactProvider from "./Context/Contact/ContactProvider";
import CustomizerProvider from "./Context/Customizer/CustomizerProvider";
import CartProvider from "./Context/Ecommerce/Cart/CartProvider";
import FilterProvider from "./Context/Ecommerce/Filter/FilterProvider";
import ProductProvider from "./Context/Ecommerce/Product/ProductProvider";
import EmailProvider from "./Context/Email/EmailProvider";
import FaqProvider from "./Context/Faq/FaqProvider";
import GalleryProvider from "./Context/Gallery/GalleryProvider";
import GoogleChartProvider from "./Context/GoogleChart/GoogleChartProvider";
import JobSearchProvider from "./Context/JobSearch/JobSearchProvider";
import LearningProvider from "./Context/Learning/LearningProvider";
import ProjectProvider from "./Context/ProjectContext/ProjectContextProvider";
import TableProvider from "./Context/Table/TableProvider";
import TaskProvider from "./Context/Task/TaskProvider";
import TodoProvider from "./Context/Todo/TodoProvider";
import Routers from "./Routes";

const App = () => {
  return (
    <>
      <CustomizerProvider>
        <JobSearchProvider>
          <LearningProvider>
            <FaqProvider>
              <GoogleChartProvider>
                <TableProvider>
                  <TodoProvider>
                    <GalleryProvider>
                      <TaskProvider>
                        <ContactProvider>
                          <BookmarkProvider>
                            <ChatProvider>
                              <EmailProvider>
                                <ProductProvider>
                                  <ProjectProvider>
                                    <CartProvider>
                                      <FilterProvider>
                                        <Routers />
                                      </FilterProvider>
                                    </CartProvider>
                                  </ProjectProvider>
                                </ProductProvider>
                              </EmailProvider>
                            </ChatProvider>
                          </BookmarkProvider>
                        </ContactProvider>
                      </TaskProvider>
                    </GalleryProvider>
                  </TodoProvider>
                </TableProvider>
              </GoogleChartProvider>
            </FaqProvider>
          </LearningProvider>
        </JobSearchProvider>
      </CustomizerProvider>
      <ToastContainer />
    </>
  );
};

export default App;
